declare function require(moduleName: string): any;
export const ModalBox = require('exports?Coveo.ModalBox!../node_modules/modal-box/bin/ModalBox.min.js');
export const MagicBox = require('exports?Coveo.MagicBox!../node_modules/coveomagicbox/bin/MagicBox.min.js');
export const LocaleString = require('exports?window.String.toLocaleString!../lib/l10n/l10n.min.js');



/** WEBPACK FOOTER **
 ** ./src/ExternalModulesShim.ts
 **/